import { render, staticRenderFns } from "./RiskPortrait.vue?vue&type=template&id=0e32d2d1&"
import script from "./RiskPortrait.vue?vue&type=script&lang=js&"
export * from "./RiskPortrait.vue?vue&type=script&lang=js&"
import style0 from "./RiskPortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/RiskPortrait.vue"
export default component.exports